$(function () {
    $('#ReserveConfirm .backBtn').click(() => {
        $('#reserve_form input[type="submit"]').prop('disabled', true)
        $('#reserve_form .backBtn').addClass('disabled')
        let action = $('#reserve_form').attr('action');
        action = action.replace("confirm_payment", "search");
        $('#reserve_form').attr('action', action);
        document.getElementById("reserve_form").submit();
    })
});